import React from 'react';
import style from './style.module.less';
import BremenLogo from 'components/BremenLogo';

function Wrapper({ children }) {
    return (
        <main className={style.container}>
            <BremenLogo />
            <div className={style.inner}>
                <div className={style.boa} />
                {children}
            </div>
        </main>
    );
}

export default Wrapper;



// WEBPACK FOOTER //
// ../components/Wrapper/index.js